import React from 'react';
import { useTheme } from '../lib/theme';

/**
 * Light/dark switch, as an icon button.
 *
 * The staff header offers this from the account menu instead, where it sits
 * with the other things that are about you rather than about the page. This
 * one remains for the contractor portal, which has a header of its own and no
 * account menu to put it in.
 *
 * The choice itself lives in lib/theme, so whichever control is on screen is
 * reading and writing the same answer.
 */
export default function ThemeToggle() {
  const { dark, toggle } = useTheme();

  return (
    <button
      type="button"
      /* A stable hook. This sits in the contractor portal's header and in the
         login page's corner, and "the button whose label happens to mention
         light or dark" is not a way to find it. */
      className="nav-icon-btn theme-toggle"
      onClick={toggle}
      title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={dark}
    >
      {dark ? (
        <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6"
             strokeLinecap="round" aria-hidden="true">
          <circle cx="9" cy="9" r="3.4" />
          <path d="M9 1.4v1.8M9 14.8v1.8M1.4 9h1.8M14.8 9h1.8M3.6 3.6l1.3 1.3M13.1 13.1l1.3 1.3M14.4 3.6l-1.3 1.3M4.9 13.1l-1.3 1.3" />
        </svg>
      ) : (
        <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6"
             strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M15.2 10.6A6.6 6.6 0 0 1 7.4 2.8a6.6 6.6 0 1 0 7.8 7.8Z" />
        </svg>
      )}
    </button>
  );
}
